import { SHOW_KEYBOARD, GENERATE_DEVICE_ID, STORE_HISTORY, GENERATE_MOBILE_ID } from '../constants/appConstants';

export const showKeyboard = (payload) => ({ type: SHOW_KEYBOARD, payload });
export const generateDeviceId = (payload) => ({ type: GENERATE_DEVICE_ID, payload });
export const storeHistory = (payload) => ({ type: STORE_HISTORY, payload });
export const mobileDeviceId = (payload) => ({ type: GENERATE_MOBILE_ID, payload});